export default {
    administrator: $localize `Administrator`,
    normal: $localize `Normal`,
    disabled: $localize `Disabled`,
}
